import JwtDecode from 'jwt-decode'

import { LocalStorageKeys } from 'shared/utils/keys'

function getAuthority(): string[] {
    const token = localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN)
    const userData: any = token ? JwtDecode(token) : null
    const userRoles = userData?.role || userData?.roles || []

    return userRoles
}

export default getAuthority
